/* @flow */

import keymirror from 'keymirror';

const NotificationConstants = keymirror({
  NOTIFICATION_ERROR: null,
  NOTIFICATION_ERROR_DISMISS: null,
  NOTIFICATION_DISABLED_ERROR: null,
  NOTIFICATION_RESET_ERROR: null,
  NOTIFICATION_SUCCESS: null,
  NOTIFICATION_SUCCESS_DISMISS: null,
  NOTIFICATION_NOT_FOUND: null
});

export { NotificationConstants };
